/**
 * Check if the given phone number starts with one of the specified numbers.
 * @param {Array} participant - An array of participants.
 * @return {Array} - An array that Eliminate participants who have more than one role with the same ID in a Purchase Order.
 */
export const validatePurchaseOrderArrayRules = participants => {
  const seen = new Set()
  const arrayFiltered = participants.filter(
    ({
      dni,
      participantProcess: {
        process: { name: processName },
        function: { name: functionName }
      },
      hideDetail
    }) => {
      if (processName === 'Orden de compra') {
        const key = `${dni}-${functionName}`
        if (seen.has(key)) {
          return false // delete duplicates
        }
        seen.add(key)
      }
      if (hideDetail === 0) {
        return true // Keep Element
      }
      return false
    }
  )
  return arrayFiltered
}
